module.exports = __webpack_public_path__ + "img/icon_tablet.b53b7efb.svg";